module.exports = __webpack_public_path__ + "img/right_icon.edc0b698.svg";